module.exports = __webpack_public_path__ + "static/media/bg_CrossSeguro.43e74346.jpg";